import dayjs from "dayjs";
import React, { PureComponent } from "react";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Line,
  ComposedChart,
  Bar,
  LineChart,
  ReferenceLine,
  Scatter,
  Cell,
} from "recharts";
import nodata from '../../src/assets/images/no-data.png'

export default class Example extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}

  render() {
    const fuelGraphData = Array.isArray(this.props.graphData) ? this.props?.graphData?.map((item) => {
      return {
        name: dayjs(item.timestamp).format("MM-DD HH:mm:ss"),
        refillfuel: parseInt(item.refillfuel ? item.refillfuel : 0),
        fuel: parseFloat(item.fuel ? item.fuel : 0),
      };
    }) : [];

    const fuelGraphLineData = Array.isArray(this.props.fuelGraphData) ? this.props.fuelGraphData.map((item) => {
      return {
        name: item.timestamp,
        fuel: parseFloat(item.fuel ? item.fuel : 0),
      };
    }) : [];

    return (
          fuelGraphData && fuelGraphData.length > 0 ? (
  <ResponsiveContainer height={200}>
    <ComposedChart
      width={500}
      height={400}
      data={fuelGraphData}
      margin={{
        top: 20,
        right: 20,
        bottom: 20,
        left: 20,
      }}
    >
      <Tooltip />

      <CartesianGrid stroke="#f5f5f5" />
      <XAxis dataKey="name" />
      <YAxis />

      <Bar dataKey="refillfuel" barSize={50} fill="green" />

      <Line
        type="monotone"
        dataKey="fuel"
        stroke="#8884d8"
        strokeWidth={4}
      />
    </ComposedChart>
  </ResponsiveContainer>
) : (
  <div
    style={{
      height: 200,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
    }}
  >
    <img
      src={nodata}
      alt="No Data"
      style={{ width: 120, opacity: 0.7 }}
    />
    <p>No graph data available</p>
  </div>
)

    );
  }
}
